import React from 'react';
import styles from './EmptyState.module.scss';
import { Heading, Text } from '../../../../../../components/Typography/Typography';

interface EmptyStateProps {
  isLoading?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ isLoading = false }) => {
  return (
    <div className={styles.emptyState}>
      {isLoading ? (
        <>
          <div className={styles.loadingIndicator}></div>
          <Text size="base" weight="medium">
            Loading conversation...
          </Text>
        </>
      ) : (
        <>
          <Heading level={2}>Hi I'm Enlo</Heading>
          <Text size="base">
            Ask me anything about finance and investments. (Optimized to S&P 500 during Beta)
          </Text>
        </>
      )}
    </div>
  );
};

export default EmptyState;
